"use client";

import { createContext, useContext, useEffect, type ReactNode } from "react";
import { defaultLocale, LOCALE_COOKIE, type Locale } from "./locales";

const I18nContext = createContext<{ locale: Locale }>({ locale: defaultLocale });

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  useEffect(() => {
    // Back/forward navigation may restore a page without making a server request.
    // Keep subsequent links in the language of the page the visitor is viewing.
    const persist = () => {
      document.documentElement.lang = locale;
      document.cookie = `${LOCALE_COOKIE}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`;
    };
    persist();
    window.addEventListener("pageshow", persist);
    return () => window.removeEventListener("pageshow", persist);
  }, [locale]);
  return <I18nContext.Provider value={{ locale }}>{children}</I18nContext.Provider>;
}

export function useI18n() { return useContext(I18nContext); }
